import { render } from "./SimpleFooter.vue?vue&type=template&id=65bdc354"
import script from "./SimpleFooter.vue?vue&type=script&lang=js"
export * from "./SimpleFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__